<template>
  <div class="modal__wrap--bg cmp-modal" :class="{'is-active' : actJnlDetailModal}" id="act-jnl-detail-template">
    <div class="modal-wrap-container modal-wd1020">
      <div class="modal-header">
        <div class="title">활동일지 {{ titleMode }}</div>
      </div>
      <div class="modal-body-container  ht-full">
        <div class="table-wrap border-top-none mt-0">
          <table class="table-body-only">
            <caption>활동일지 정보 테이블</caption>
            <colgroup class="pc-cell">
              <col style="width: 160px;" />
              <col />
            </colgroup>
            <colgroup class="mo-cell">
              <col style="width: 88px;" />
             <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">세부사업명</th>
                <td>{{ actJnlData.BIZNM }}</td>
              </tr>
              <tr>
                <th scope="row">활동월</th>
                <td>{{ actJnlData.ACCYYYY }}년 {{ actJnlData.ACCMM }}월</td>
              </tr>
              <tr>
                <th scope="row">활동 구분</th>
                <td>
                  <div class="input-area mo-size wid400">
                    <select title="활동 구분 선택" v-model="actJnlData.ACT_SE" :disabled="!isEdit" ref="actSe" :class="{ 'is-disabled' : !isEdit }">
                      <option value="">활동 구분 선택</option>
                      <option v-for="item in jb14Codes" :key="item.code" :value="item.code">{{ item.name }}</option>
                      <!-- <fpms:codeOption mstCd="JB14" dtlCd="${ActJnlData.ACT_SE}"/> -->
                    </select>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">활동 제목</th>
                <td>
                  <div class="input-area wid100p">
                    <input type="text" placeholder="입력해 주세요." v-model="actJnlData.ACT_SJ" :disabled="!isEdit" ref="actSj" title="활동제목">
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">활동 일자</th>
                <td>
                  <div class="input-area mo-size wid120">
                    <input type="date" placeholder="입력해 주세요." v-model="actJnlData.ACT_DE" :disabled="!isEdit" max="9999-12-31" ref="actDe" @change="checkActDe" title="활동 일자">
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">활동 시간</th>
                <td>
                  <div class="time-select-group">
                    <div class="time-select-item">
                      <label for="start-hour">시작시간</label>
                      <div class="input-area wid88">
                        <select id="start-hour" title="시작시간 시 선택" class="form-control" v-model="actJnlData.ACT_STTM_HH" :disabled="!isEdit" ref="actSttmHh" :class="{ 'is-disabled' : !isEdit }">
                          <option value="">시작시간 시 선택</option>
                          <option v-for="(hour, index) in hours" :key="index" :value="hour">{{ hour }}</option>
                        </select>
                      </div>
                      시
                      <div class="input-area wid88">
                        <select id="start-minute" title="시작시간 분 선택" class="form-control" v-model="actJnlData.ACT_STTM_MM" :disabled="!isEdit" ref="actSttmMm" :class="{ 'is-disabled' : !isEdit }">
                          <option value="">시작시간 분 선택</option>
                          <option v-for="(minute, index) in minutes" :key="index" :value="minute">{{ minute }}</option>
                        </select>
                      </div>
                      분
                    </div>
                    <div class="time-select-item">
                      <label for="end-hour">종료시간</label>
                      <div class="input-area wid88">
                        <select id="end-hour" title="종료시간 시 선택" v-model="actJnlData.ACT_EDTM_HH" :disabled="!isEdit" ref="actEdtmHh" :class="{ 'is-disabled' : !isEdit }">
                          <option value="">종료시간 시 선택</option>
                          <option v-for="(hour, index) in hours" :key="index" :value="hour">{{ hour }}</option>
                        </select>
                      </div>
                      시
                      <div class="input-area wid88">
                        <select id="end-minute"  title="종료시간 분 선택" v-model="actJnlData.ACT_EDTM_MM" :disabled="!isEdit" ref="actEdtmMm" :class="{ 'is-disabled' : !isEdit }">
                          <option value="">종료시간 분 선택</option>
                          <option v-for="(minute, index) in minutes" :key="index" :value="minute">{{ minute }}</option>
                        </select>
                      </div>
                      분
                    </div>
                    <div class="time-select-item">
                      <label for="recognition-time">활동시간</label>
                      <div class="input-area mo-size wid200" >
                        <!-- <input type="text" v-model="actJnlData.ACT_TM" :disabled="true" title=" 입력" /> -->
                        {{ formatTime(actJnlData.ACT_TM) }}
                      </div>
                    </div>
                    <div class="time-select-item">
                      <label for="lunch">중식</label>
                      <div class="input-area wid200">
                        <select id="lunch"  title="중식 선택" v-model="actJnlData.LUNCH_CD" :disabled="!isEdit" ref="lunchCd" :class="{ 'is-disabled' : !isEdit }">
                          <option value="">중식 선택</option>
                          <option v-for="item in jb15Codes" :key="item.code" :value="item.code">{{ item.name }}</option>
                          <!-- <fpms:codeOption mstCd="JB15" dtlCd="${ActJnlData.LUNCH_CD}"/> -->
                        </select>
                      </div>
                    </div>
                    <div class="time-select-item">
                      <label for="dinner">석식</label>
                      <div class="input-area wid200">
                        <select id="dinner"  title="석식 선택" v-model="actJnlData.DINNER_CD" :disabled="!isEdit" ref="dinnerCd" :class="{ 'is-disabled' : !isEdit }">
                          <option value="">석식 선택</option>
                          <option v-for="item in jb16Codes" :key="item.code" :value="item.code">{{ item.name }}</option>
                          <!-- <fpms:codeOption mstCd="JB16" dtlCd="${ActJnlData.DINNER_CD}"/> -->
                        </select>
                      </div>
                    </div>
                    <div class="time-select-item">
                      <label for="recognition-time">가중치적용</label>
                      <div class="input-area mo-size wid200">
                        <select id="recognition-time" :class="{ 'is-disabled' : !isEdit }" title="가중치 적용 선택" v-model="actJnlData.WORK_SE" :disabled="!isEdit" ref="workSe">
                          <option value="">가중치 적용 선택</option>
                          <option v-for="item in jb39Codes" :key="item.code" :value="item.code">{{ item.name }}</option>
                          <!-- <fpms:codeOption mstCd="JB39" dtlCd="${ActJnlData.WORK_SE}"/> -->
                        </select>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">세부활동<br class="mo-only"> 내용 및<br> 특이사항</th>
                <td>
                  <div class="textarea-wrap wid100p ht-200">
                    <textarea placeholder="입력해 주세요." v-model="actJnlData.NOTE" :disabled="!isEdit" ref="note" title="세부활동 내용 및 특이사항" maxlength="1000"></textarea>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-md button-wid150" @click="close">
          닫기
        </button>
        <button type="button" class="btn btn-primary btn-md button-wid150" @click="save" v-if="mode !== 'View'">
          저장하기
        </button>
        <button type="button" class="btn btn-primary btn-md button-wid150" @click="report" v-if="actJnlData.DAILDOC_CFM_STAT === 'JB30001'">
          출력하기
        </button>
      </div>
      <button type="button" class="btn btn-close only-icon close-modal" aria-label="닫기" @click="close" title="닫기">
        <i class="ico ico-x-bl"></i>
      </button>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';
import moment from 'moment';

const hours = [
  '00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11',
  '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23',
];

const minutes = [
  '00', '30',
];

export default {
  name: 'act-jnl-detail-template',
  props: ['actJnlDetailModal', 'mode', 'JNL_SEQ', 'bindData'],
  components: {},
  data() {
    return {
      hours,
      minutes,
      jb14Codes: [],
      jb15Codes: [],
      jb16Codes: [],
      jb39Codes: [],
      actJnlData: {
        APP_NO: 0,
        MD_APP_NO: 0,
        ACCYYYY: '',
        ACCMM: '',
        ACT_TM: '',
        ADMIT_ACT_TM: '',
        ACT_SE: '',
        ACT_SJ: '',
        CHK_FLAG: 'Y',
        ACT_DE: '',
        ACT_STTM_HH: '',
        ACT_STTM_MM: '',
        ACT_EDTM_HH: '',
        ACT_EDTM_MM: '',
        MD_ACTCOMP_NO: '',
        MD_ANN_ACTCOMP_NO: 0,
        ACTCOMP_NO: 0,
        ACT_STTM: '',
        ACT_EDTM: '',
        BIZNM: '',
        JNL_SEQ: 0,
        MD_SEQ: '',
        ACT_TM_BF: '',
        LUNCH_CD: '',
        DINNER_CD: '',
        WORK_SE: '',
      },
      isEdit: true,
      titleMode: '',
      annActionFeeList: [], // 추가비용 내역
    };
  },
  watch: {
    actJnlDetailModal: {
      handler(newVal) {
        if (newVal) this.getData();
      },
    },
    'actJnlData.ACT_STTM_HH'() {
      this.getActTm();
    },
    'actJnlData.ACT_STTM_MM'() {
      this.getActTm();
    },
    'actJnlData.ACT_EDTM_HH'() {
      this.getActTm();
    },
    'actJnlData.ACT_EDTM_MM'() {
      this.getActTm();
    },
    'actJnlData.LUNCH_CD'() {
      this.getActTm();
    },
    'actJnlData.DINNER_CD'() {
      this.getActTm();
    },
    'actJnlData.WORK_SE'() {
      this.getActTm();
    },
  },
  methods: {
    getData() {
      this.actJnlData.MD_APP_NO = this.bindData.APP_NO;
      this.actJnlData.APP_NO = this.bindData.APP_NO;
      this.actJnlData.BIZNM = this.bindData.BIZNM;
      this.actJnlData.ACCYYYY = this.bindData.ACCYYYY;
      this.actJnlData.ACCMM = this.bindData.ACCMM;
      this.actJnlData.MD_ACTCOMP_NO = this.bindData.ACTCOMP_NO;
      this.actJnlData.ACTAMT_HAMT = this.bindData.ACTAMT_HAMT;
      this.actJnlData.ANN_NO = this.bindData.ANN_NO;
      this.actJnlData.MD_ANN_ACTCOMP_NO = this.bindData.ANN_ACTCOMP_NO;
      this.actJnlData.JNL_SEQ = this.JNL_SEQ;

      // Regist, Modify, View
      if (this.actJnlDetailModal) {
        if (this.mode === 'Regist') {
          this.getActJnlRgst();
          this.isEdit = true;
          this.titleMode = '등록';
        } else {
          this.getActJnlData();
        }
      }
    },
    getActJnlData() {
      const url = '/api/act/actJnlDetail';
      Axios.get(url, { params: this.actJnlData }).then((response) => {
        if (response.data.success === 'R') {
          const newData = response.data.data.ActJnlData;
          this.actJnlData.ACT_STTM = newData.ACT_STTM;
          this.actJnlData.LUNCH_CD = newData.LUNCH_CD;
          this.actJnlData.ACT_TM = newData.ACT_TM;
          this.actJnlData.ADMIT_ACT_TM = newData.ADMIT_ACT_TM;
          this.actJnlData.ACT_EDTM = newData.ACT_EDTM;
          this.actJnlData.ACT_SJ = newData.ACT_SJ;
          this.actJnlData.APP_NO = newData.APP_NO;
          this.actJnlData.ACT_DE = moment(newData.ACT_DE, 'YYYYMMDD').format('YYYY-MM-DD');
          this.actJnlData.DAILDOC_APPRV_STAT = newData.DAILDOC_APPRV_STAT;
          this.actJnlData.ACT_EDTM_HH = newData.ACT_EDTM_HH;
          this.actJnlData.ACT_EDTM_MM = newData.ACT_EDTM_MM;
          this.actJnlData.WORK_SE = newData.WORK_SE;
          this.actJnlData.DAILDOC_CFM_STAT = newData.DAILDOC_CFM_STAT;
          this.actJnlData.ACT_STTM_HH = newData.ACT_STTM_HH;
          this.actJnlData.ACT_STTM_MM = newData.ACT_STTM_MM;
          this.actJnlData.NOTE = newData.NOTE;
          this.actJnlData.DINNER_CD = newData.DINNER_CD;
          this.actJnlData.ACTCOMP_NO = newData.ACTCOMP_NO;
          this.actJnlData.ACT_SE = newData.ACT_SE;
          this.actJnlData.SEQ = newData.SEQ;
          this.actJnlData.ACT_TM_BF = newData.ACT_TM;
          this.actJnlData.MD_ACTCOMP_NO = newData.ACTCOMP_NO;
          this.actJnlData.MD_SEQ = newData.SEQ;
          this.ACT_TM_BF = newData.ACT_TM;
          this.actJnlData.MD_APP_NO = newData.APP_NO;

          // JB38001 JB38 승인
          // JB30001 JB30 확정
          if (newData.DAILDOC_APPRV_STAT === 'JB38001' || newData.DAILDOC_CFM_STAT === 'JB30001') {
            this.mode = 'View';
            this.isEdit = false;
            this.titleMode = '상세';
          } else {
            this.mode = 'Modify';
            this.isEdit = true;
            this.titleMode = '수정';
            this.actJnlData.CHK_FLAG = 'N';
          }
        }
      }).catch((e) => {
        console.log(e);
      });
    },
    getActJnlRgst() {
      Axios.get('/api/act/actJnlRgst', { params: { ...this.actJnlData } }).then((response) => {
        this.annActionFeeList = response.data.data.annActionFeeList;
      }).catch((e) => {
        console.log(e.data);
      });
    },
    report() {
      window.open('https://rpt.50plus.or.kr/actReport.do?SEQ=' + this.actJnlData.SEQ, 'PopupWin', 'width=1200,height=900');
      // window.open(`/actReport.do?SEQ=${this.actJnlData.SEQ}`, 'PopupWin', 'width=1200,height=900');
    },
    save() {
      this.getActTm();
      if (this.validChecked() && this.fn_chkActTm() && confirm('저장하시겠습니까?')) {
        if (this.actJnlData.ACT_TM > this.ACT_TM_BF) {
          this.actJnlData.CHK_FLAG = "Y";
        }
        Axios.get('/mypage-checkActAdmitTm', { params: { ...this.actJnlData } })
          .then((res) => {
            if (res.data.ckeckMpact === 'N') {
              alert("활동일지 작성을 완료할 수 없습니다.(동일시간대에 활동일지내역이 존재합니다.)");
            } else if (res.data.checkResult === 'OK' && res.data.ckeckMpact !== 'N' && res.data.ckeckMember === 'success') {
              (this.mode === 'Regist') ? this.regist() : this.modify();
            } else if (res.data.checkResult === 'NO') {
              alert(`월별 최대활동시간(${res.data.targetTm}시간)을 초과하여 입력하였습니다. 입력한 활동일지를 확인해보시기 바랍니다.`);
            } else if (res.data.ckeckMember === 'faile') {
              alert('저장을 실패했습니다.(로그인 상태를 확인해주세요.)');
            }
          });
      }
    },
    regist() {
      this.actJnlData.ACT_STTM = `${this.actJnlData.ACT_STTM_HH}${this.actJnlData.ACT_STTM_MM}`;
      this.actJnlData.ACT_EDTM = `${this.actJnlData.ACT_EDTM_HH}${this.actJnlData.ACT_EDTM_MM}`;
      Axios.post('/mypage-ActJnlRgstInsert', { params: { ...this.actJnlData } })
        .then((response) => {
          if (response.data.success === 'C') {
            alert('저장되었습니다');
            this.$emit('reloadList');
            this.close();
          } else {
            // 서버 재검증(월 최대활동시간 초과 / 동일시간대 중복)에 걸린 경우 — 모달은 열어 둔다
            alert(response.data.msg || '저장에 실패했습니다. 입력 내용을 확인해 주세요.');
            this.$emit('reloadList');
          }
      }).catch(() => {
        alert('저장에 실패했습니다. 잠시 후 다시 시도해 주세요.');
      });
    },
    modify() {
      this.actJnlData.ACT_STTM = `${this.actJnlData.ACT_STTM_HH}${this.actJnlData.ACT_STTM_MM}`;
      this.actJnlData.ACT_EDTM = `${this.actJnlData.ACT_EDTM_HH}${this.actJnlData.ACT_EDTM_MM}`;
      Axios.post('/mypage-ActJnlRgstModify', { params: { ...this.actJnlData } })
        .then((response) => {
          if (response.data.success === 'C') {
            alert('저장되었습니다');
            this.$emit('reloadList');
            this.close();
          } else {
            // 서버 재검증(월 최대활동시간 초과 / 동일시간대 중복)에 걸린 경우 — 모달은 열어 둔다
            alert(response.data.msg || '저장에 실패했습니다. 입력 내용을 확인해 주세요.');
            this.$emit('reloadList');
          }
      }).catch(() => {
        alert('저장에 실패했습니다. 잠시 후 다시 시도해 주세요.');
      });
    },
    validChecked() {
      if (!this.actJnlData.ACT_SE || this.actJnlData.ACT_SE === '') {
        alert('활동 구분을 선택해주세요.');
        this.$refs.actSe.focus();
        return false;
      } else if (!this.actJnlData.ACT_SJ || this.actJnlData.ACT_SJ === '') {
        alert('활동 제목을 입력해주세요.');
        this.$refs.actSj.focus();
        return false;
      } else if (!this.actJnlData.ACT_DE || this.actJnlData.ACT_DE === '') {
        alert('활동 일자를 입력해주세요.');
        this.$refs.actDe.focus();
        return false;
      } else if (!this.actJnlData.ACT_STTM_HH || this.actJnlData.ACT_STTM_HH === '') {
        alert('활동 시작 시간을 입력해주세요.');
        this.$refs.actSttmHh.focus();
        return false;
      } else if (!this.actJnlData.ACT_STTM_MM || this.actJnlData.ACT_STTM_MM === '') {
        alert('활동 시작 시간을 입력해주세요.');
        this.$refs.actSttmMm.focus();
        return false;
      } else if (!this.actJnlData.ACT_EDTM_HH || this.actJnlData.ACT_EDTM_HH === '') {
        alert('활동 종료 시간을 입력해주세요.');
        this.$refs.actEdtmHh.focus();
        return false;
      } else if (!this.actJnlData.ACT_EDTM_MM || this.actJnlData.ACT_EDTM_MM === '') {
        alert('활동 종료 시간을 입력해주세요.');
        this.$refs.actEdtmMm.focus();
        return false;
      } else if (!this.actJnlData.LUNCH_CD || this.actJnlData.LUNCH_CD === '') {
        alert('중식 여부을 선택해주세요.');
        this.$refs.lunchCd.focus();
        return false;
      } else if (!this.actJnlData.DINNER_CD || this.actJnlData.DINNER_CD === '') {
        alert('석식 여부을 선택해주세요.');
        this.$refs.dinnerCd.focus();
        return false;
      } else if (!this.actJnlData.WORK_SE || this.actJnlData.WORK_SE === '') {
        alert('가중치 여부을 선택해주세요.');
        this.$refs.workSe.focus();
        return false;
      } else if (!this.actJnlData.NOTE || this.actJnlData.NOTE === '') {
        alert('활동내역 및 특이사항을 입력해주세요.');
        this.$refs.note.focus();
        return false;
      }
      return true;
    },
    checkActDe() {
      const today = moment(); // 현재 날짜와 시간
      const actDe = moment(this.actJnlData.ACT_DE, 'YYYY-MM-DD');
      if (actDe.isAfter(today)) {
        alert("활동일지는 활동하지 않은 날짜로 미리 작성하실 수 없습니다.");
        this.actJnlData.ACT_DE = '';
      }

      if (`${this.actJnlData.ACCYYYY}${this.actJnlData.ACCMM}` !== actDe.format('YYYYMM')) {
        alert("활동월에서 벗어난 날은 선택할 수 없습니다.");
        this.actJnlData.ACT_DE = '';
      }
    },
    fn_chkActTm() {
      const stActTm = Number(`${this.actJnlData.ACT_STTM_HH}${this.actJnlData.ACT_STTM_MM}`);
      const edActTm = Number(`${this.actJnlData.ACT_EDTM_HH}${this.actJnlData.ACT_EDTM_MM}`);

      const actTM = this.actJnlData.ACT_TM;

      let flag = true;

      if (edActTm < stActTm) {
        alert("입력하신 활동종료시간이 활동시작시간전입니다. 다시 입력해주세요.");
        flag = false;
      }

      if (actTM === "00:00") {
        alert("활동시간을 체크해 주십시오.");
        flag = false;
      }

      return flag;
    },
    getActTm() {
      if (!this.actJnlData.ACT_STTM_HH || !this.actJnlData.ACT_STTM_MM || !this.actJnlData.ACT_EDTM_HH || !this.actJnlData.ACT_EDTM_MM) {
        return '';
      }
      const sttmTmp = moment(`2017-01-01 ${this.actJnlData.ACT_STTM_HH}:${this.actJnlData.ACT_STTM_MM}:01`);
      const edtmTmp = moment(`2017-01-01 ${this.actJnlData.ACT_EDTM_HH}:${this.actJnlData.ACT_EDTM_MM}:01`);

      let diff_second = Math.floor(moment.duration(edtmTmp.diff(sttmTmp)).asSeconds());

      if (this.actJnlData.LUNCH_CD === 'JB15001') diff_second -= 3600;
      if (this.actJnlData.LUNCH_CD === 'JB15003') diff_second -= 1800;
      if (this.actJnlData.DINNER_CD === 'JB16001') diff_second -= 3600;
      if (this.actJnlData.DINNER_CD === 'JB16003') diff_second -= 1800;

      diff_second = (diff_second < 0) ? 0 : diff_second;

      if (this.actJnlData.WORK_SE !== '' && this.actJnlData.WORK_SE !== 'JB39001' && this.actJnlData.WORK_SE !== 'JB39005' && this.actJnlData.WORK_SE !== 'JB39006') {
        diff_second *= 1.5;
      }

      const mm = Math.floor(diff_second / 60);
      const hh = Math.floor(mm / 60);

      const diff_hour = Math.floor(hh % 24);
      const diff_minute = Math.floor(mm % 60);

      const hour = String(diff_hour).length >= 2 ? diff_hour : new Array(2 - String(diff_hour).length + 1).join('0') + diff_hour;
      const minute = String(diff_minute).length >= 2 ? diff_minute : new Array(2 - String(diff_minute).length + 1).join('0') + diff_minute;

      const actTm = `${hour}:${minute}`;
      this.actJnlData.ACT_TM = actTm;
    },
    formatTime(time) {
      // null, undefined, 빈 문자열, 숫자 등 모든 경우 처리
      if (!time || typeof time !== 'string' || time.trim() === '') {
        return '0시간 0분';
      }

      const timeSlice = time.split(':');

      // split 결과가 올바른지 확인
      if (timeSlice.length < 2) {
        return '0시간 0분';
      }

      const hours = timeSlice[0] || '0';
      const minutes = timeSlice[1] || '0';

      return `${hours}시간 ${minutes}분`;
    },
    getJB14Codes() {
      Axios.get('/api/common-codes/getCodes?parentCode=JB14')
        .then((response) => {
          this.jb14Codes = response.data;
        }).catch((e) => {
          console.log(e);
        });
    },
    getJB15Codes() {
      Axios.get('/api/common-codes/getCodes?parentCode=JB15')
        .then((response) => {
          this.jb15Codes = response.data;
        }).catch((e) => {
          console.log(e);
        });
    },
    getJB16Codes() {
      Axios.get('/api/common-codes/getCodes?parentCode=JB16')
        .then((response) => {
          this.jb16Codes = response.data;
        }).catch((e) => {
          console.log(e);
        });
    },
    getJB39Codes() {
      Axios.get('/api/common-codes/getCodes?parentCode=JB39')
        .then((response) => {
          this.jb39Codes = response.data;
        }).catch((e) => {
          console.log(e);
        });
    },
    close() {
      this.actJnlData = {
        APP_NO: 0,
        MD_APP_NO: 0,
        ACCYYYY: '',
        ACCMM: '',
        ACT_TM: '',
        ADMIT_ACT_TM: '',
        ACT_SE: '',
        ACT_SJ: '',
        CHK_FLAG: 'Y',
        ACT_DE: '',
        ACT_STTM_HH: '',
        ACT_STTM_MM: '',
        ACT_EDTM_HH: '',
        ACT_EDTM_MM: '',
        MD_ACTCOMP_NO: '',
        MD_ANN_ACTCOMP_NO: 0,
        ACTCOMP_NO: 0,
        ACT_STTM: '',
        ACT_EDTM: '',
        BIZNM: '',
        JNL_SEQ: 0,
        MD_SEQ: '',
        ACT_TM_BF: '',
        LUNCH_CD: '',
        DINNER_CD: '',
        WORK_SE: '',
      };
      this.$emit('update:actJnlDetailModal', false);
      $('body').removeClass('modal-open');
    },
  },
  mounted() {
    this.getJB14Codes();
    this.getJB15Codes();
    this.getJB16Codes();
    this.getJB39Codes();
  },
};
</script>

<style scoped>
.input-area select:disabled {
  background-color: #fff !important;
  color: #222 !important;
  -webkit-text-fill-color: #222 !important;
  opacity: 1 !important;
}
</style>



// WEBPACK FOOTER //
// ActJnlDetail.vue?1463b8ad